export const getAmountOfMessagesEndpoint =
  '/inbox-ms/ms/inbox/getNumberMessage';

export const getMessageListEndpoint = '/inbox-ms/ms/inbox/getMessageList';

export const setMessageInfoEndpoint = '/inbox-ms/ms/inbox/setInfoMessage';

export const bulkEditMessageInfosEndpoint = '/inbox-ms/ms/inbox/notifyMessages';
